import { AUTH as types } from '@store/constants';
import api from '@api/endpoints';
import authTokenStorage from '@auth';
import { setAlert } from '@store/actions/alertActions';
import { ALERT_STATUS_TYPE } from '@constants';
import { AUTH_TOKEN_STORAGE_KEYS } from '@auth/constants';


const getAppData = async () => {
  if (!authTokenStorage.getAppToken(AUTH_TOKEN_STORAGE_KEYS.APP_TOKEN)) return Promise.reject();

  const { data } = await api.auth.me();
  return data;
};

export const login =
  ({ username, password }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: types.LOGGING_IN
      });

      const { data } = await api.auth.login({ username, password });

      if (!data?.accessToken)
        return dispatch({
          type: types.LOGIN_FAILURE,
          payload: {
            message: 'access_token missing in response',
            error: data
          }
        });

      authTokenStorage.setAppToken(data.accessToken);
      authTokenStorage.setUserRole(data.role);
      const userData = await getAppData();

      return dispatch({
        type: types.LOGIN_SUCCESS,
        payload: {
          userData,
          role: data.role
        }
      });
    } catch (error) {
      const message =
        error.code === 'ECONNABORTED'
          ? 'Please connect to VPN!'
          : error.message;
      dispatch(setAlert({ title: message, status: ALERT_STATUS_TYPE.ERROR }));

      return dispatch({
        type: types.LOGIN_FAILURE,
        payload: error
      });
    }
  };

export const loginFromLocalStorage = ({onSuccess}) => async (dispatch) => {
  try {
    dispatch({
      type: types.LOGGING_IN
    });

    const userData = await getAppData();
    const role = await authTokenStorage.getUserRole();

    dispatch({
      type: types.LOGIN_SUCCESS,
      payload: {
        userData,
        role
      }
    });

    onSuccess && onSuccess();
  } catch (error) {
    return dispatch({
      type: types.LOGIN_FROM_LOCAL_STORAGE_FAILURE
    });
  }
};

export const refresh = () => async (dispatch) => {
  try {
    dispatch({
      type: types.LOGGING_IN
    });

    const userData = await getAppData();

    return dispatch({
      type: types.LOGIN_SUCCESS,
      payload: userData
    });
  } catch (error) {
    return dispatch({
      type: types.LOGIN_FAILURE,
      payload: error
    });
  }
};

export const logout = () => async (dispatch) => {
  try {
    await authTokenStorage.removeAppToken();
    return dispatch({
      type: types.LOGOUT
    });
  } catch (error) {
    return dispatch({
      type: types.LOGOUT_FAILURE
    });
  }
};

export const loginWithGoogle = (googleToken) => async (dispatch) => {
  try {
    dispatch({
      type: types.LOGGING_IN
    });

    const { data } = await api.auth.loginWithGoogle({ googleToken });

    if (!data?.accessToken)
      return dispatch({
        type: types.LOGIN_FAILURE,
        payload: {
          message: 'access_token missing in response',
          error: data
        }
      });

    authTokenStorage.setAppToken(data.accessToken);
    authTokenStorage.setUserRole(data.role);
    const userData = await getAppData();

    return dispatch({
      type: types.LOGIN_SUCCESS,
      payload: {
        userData,
        role: data.role
      }
    });
  } catch (error) {
    const message =
      error.code === 'ECONNABORTED'
        ? 'Please connect to VPN!'
        : error.message || 'Google authentication failed';

    dispatch(
      setAlert({
        title: message,
        status: ALERT_STATUS_TYPE.ERROR
      })
    );

    return dispatch({
      type: types.LOGIN_FAILURE,
      payload: error
    });
  }
};
